import config from "../config"
const baseUrl = config.base_url + "lz_sample/"
export default {
    getById: {
        url: baseUrl + "getById?key=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9",
        type: "get",
    },
    list: {
        url: baseUrl + "list?key=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9",
        type: "post",
    }
}
